import { AdminFinancialCacheScreen } from '@features/admin/ui/AdminFinancialCacheScreen'

export function FinancialCachePage() {
  return <AdminFinancialCacheScreen />
}
